/**
 * WelcomeStep — step 0 content (016 Onboarding Wizard, spec FR-002).
 *
 * Renders the welcome illustration. The wizard orchestrator wraps this in
 * `OnboardingStep` and supplies title, description, CTA, and progress.
 *
 * Illustration is a placeholder SVG (spec OQ-03) — the final WebP swaps in
 * after customer review without touching this component.
 */

import type { JSX } from 'react';

import welcomeIllustration from '../../assets/onboarding-welcome.png';

const imageClasses = 'w-full h-auto max-h-onboarding-illustration object-contain rounded-2xl';

export function WelcomeStep(): JSX.Element {
  // Empty alt — the illustration is decorative; the step title + body carry
  // the semantic content. Marking it presentational keeps assistive tech
  // from announcing redundant placeholder copy.
  return <img src={welcomeIllustration} alt="" className={imageClasses} draggable={false} />;
}
